module.exports = __webpack_public_path__ + "static/media/order-promised.271fc580.svg";